"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCopiesMiddleware = void 0;
const react_1 = __importDefault(require("react"));
const useCopiesMiddleware = () => {
    const [copiesCount, setCopiesCount] = react_1.default.useState(1);
    return { copiesCount, setCopiesCount };
};
exports.useCopiesMiddleware = useCopiesMiddleware;
